export const characterList = [
  {
    id: "c1",
    name: "林星晨",
    work: "星海纪元",
    workId: "r1",
    gender: "女",
    voiceActor: "花玲",
    image: "https://readdy.ai/api/search-image?query=Anime%20character%20portrait%20of%20a%20confident%20young%20female%20space%20pilot%20with%20short%20dark%20hair%20and%20glowing%20amber%20eyes%2C%20sleek%20white%20and%20yellow%20flight%20suit%2C%20clean%20soft%20background%2C%20warm%20lighting%2C%20detailed%20digital%20illustration%2C%20no%20text&width=600&height=800&seq=banana-char-01&orientation=portrait",
    intro: "银河远征军最年轻的领航员，看似柔弱却拥有超乎常人的空间感知能力，是整支舰队不可或缺的「眼睛」。",
    background: [
      "林星晨出生于边境的矿业星站，在资源匮乏的环境中长大。为了改变家乡的命运，她以优异的成绩考入星际航行学院。",
      "在一次远征任务中，舰队遭遇了罕见的星海风暴，她凭借精准的判断带领全舰脱险，从此被委以领航员的重任。",
      "尽管天赋出众，她始终对自己缺乏信心。随着旅程的推进，她要在一次次的抉择中学会承担与信任。",
    ],
    tags: ["领航员", "主角", "成长型"],
  },
  {
    id: "c2",
    name: "夜见初雪",
    work: "幻境学院",
    workId: "r4",
    gender: "女",
    voiceActor: "早见",
    image: "https://readdy.ai/api/search-image?query=Anime%20character%20portrait%20of%20an%20elegant%20silver%20haired%20magical%20academy%20student%20with%20gentle%20expression%2C%20flowing%20silver%20hair%2C%20elegant%20school%20uniform%2C%20soft%20dreamy%20background%2C%20warm%20golden%20lighting%2C%20detailed%20digital%20illustration%2C%20no%20text&width=600&height=800&seq=banana-char-02&orientation=portrait",
    intro: "幻境学院的学生会长，气质清冷、成绩优异，却被认为是唤醒沉睡千年的古老法器的关键人物。",
    background: [
      "夜见初雪出生于历史悠久的魔法世家，自幼便展现出惊人的魔力天赋。作为转学生来到幻境学院后，她迅速成为众人瞩目的焦点。",
      "与清冷的外表不同，她内心温柔且重情义。面对学院中的危机，她总是第一个挺身而出的人。",
      "在意外唤醒古老法器后，她背负起了本不属于她的重担。她与伙伴们的关系，也在一次次并肩作战中悄然改变。",
    ],
    tags: ["学生会长", "高人气", "魔法"],
  },
  {
    id: "c3",
    name: "白泽",
    work: "山海食记",
    workId: "r5",
    gender: "男",
    voiceActor: "阿杰",
    image: "https://readdy.ai/api/search-image?query=Anime%20character%20portrait%20of%20a%20friendly%20young%20male%20chef%20with%20warm%20smile%20and%20slight%20stubble%2C%20white%20chef%20apron%20over%20casual%20clothes%2C%20cozy%20warm%20kitchen%20background%2C%20soft%20golden%20lighting%2C%20detailed%20digital%20illustration%2C%20no%20text&width=600&height=800&seq=banana-char-03&orientation=portrait",
    intro: "小镇家庭餐馆的年轻厨师，继承了祖父留下的神秘古食谱，拥有一手能「召唤神兽」的厨艺。",
    background: [
      "白泽从小跟着祖父在餐馆里长大，耳濡目染间练就了一手好厨艺。祖父离世后，他独自挑起了经营餐馆的重担。",
      "在一次整理旧物时，他发现了那本记载着上古菜肴的古食谱。每当他成功复刻其中一道菜，便会有神兽现身。",
      "面对突如其来的奇遇，他始终保持着对食物最朴素的热爱——用一餐一饭，温暖每一个走进餐馆的人。",
    ],
    tags: ["厨师", "治愈系", "主角"],
  },
  {
    id: "c4",
    name: "桐生缘",
    work: "樱花之约",
    workId: "r2",
    gender: "女",
    voiceActor: "毛豆",
    image: "https://readdy.ai/api/search-image?query=Anime%20character%20portrait%20of%20a%20sweet%20teenage%20girl%20with%20long%20dark%20hair%20and%20a%20cherry%20blossom%20hairpin%2C%20summer%20school%20uniform%2C%20soft%20pink%20petal%20background%2C%20gentle%20warm%20lighting%2C%20detailed%20digital%20illustration%2C%20no%20text&width=600&height=800&seq=banana-char-04&orientation=portrait",
    intro: "《樱花之约》的女主角，外表柔弱内心倔强的转学生，在毕业季与青梅竹马重逢。",
    background: [
      "桐生缘因家庭原因回到故乡小镇，转学进入曾经就读的高中，与儿时的玩伴意外重逢。",
      "她温柔细腻，却总把心事藏在心里。那个儿时未能兑现的「樱花之约」，一直是支撑她坚持下去的秘密。",
      "在高中最后的一年里，她学会了直面自己的心意，也懂得了有些告别，是为了让约定变得更加珍贵。",
    ],
    tags: ["青春", "女主", "治愈"],
  },
  {
    id: "c5",
    name: "雷戈",
    work: "机械之心",
    workId: "r3",
    gender: "男",
    voiceActor: "刘以嘉",
    image: "https://readdy.ai/api/search-image?query=Anime%20character%20portrait%20of%20a%20serious%20young%20male%20mecha%20pilot%20with%20dark%20spiky%20hair%20and%20piercing%20eyes%2C%20black%20and%20orange%20flight%20suit%20with%20glowing%20details%2C%20industrial%20hangar%20background%2C%20dramatic%20lighting%2C%20detailed%20digital%20illustration%2C%20no%20text&width=600&height=800&seq=banana-char-05&orientation=portrait",
    intro: "《机械之心》的主角，寡言少语的年轻驾驶员，与自己的机体之间存在着超越常理的神秘联系。",
    background: [
      "雷戈在战火中失去了家人，被军队收养并培养成为一名人形兵器驾驶员。沉默是他面对世界的方式。",
      "他与人称「机械之心」的机体之间有着奇妙的心灵感应，这种天赋让他在战场上所向披靡，也让他备受猜忌。",
      "在残酷的战争中，他一次次面对生死与信念的考验，逐渐理解了力量真正的意义，以及自己想要守护的东西。",
    ],
    tags: ["驾驶员", "主角", "机甲"],
  },
  {
    id: "c6",
    name: "苏离",
    work: "剑与晨星",
    workId: "r6",
    gender: "女",
    voiceActor: "幽舞越山",
    image: "https://readdy.ai/api/search-image?query=Anime%20character%20portrait%20of%20a%20brave%20young%20swordswoman%20with%20flowing%20dark%20hair%20and%20determined%20expression%2C%20traveler%20cloak%20over%20light%20armor%2C%20warm%20sunrise%20sky%20background%2C%20heroic%20warm%20lighting%2C%20detailed%20digital%20illustration%2C%20no%20text&width=600&height=800&seq=banana-char-06&orientation=portrait",
    intro: "《剑与晨星》的女主角，为寻找失落的晨星之剑而独自踏上旅程的少女剑士。",
    background: [
      "苏离出身于没落的剑术世家，自小便立誓要寻回家族守护的圣物——晨星之剑。",
      "她性格坚毅、重情重义，旅途中的每一次相遇与别离，都让她对「力量」有了新的理解。",
      "在与伙伴们并肩作战的过程中，她逐渐明白，真正支撑她走下去的，从来不是手中的剑，而是心中的信念。",
    ],
    tags: ["剑士", "女主", "冒险"],
  },
];